import { render, staticRenderFns } from "./StepIdentification.vue?vue&type=template&id=09957d56&"
import script from "./StepIdentification.vue?vue&type=script&lang=js&"
export * from "./StepIdentification.vue?vue&type=script&lang=js&"
import style0 from "./StepIdentification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09957d56')) {
      api.createRecord('09957d56', component.options)
    } else {
      api.reload('09957d56', component.options)
    }
    module.hot.accept("./StepIdentification.vue?vue&type=template&id=09957d56&", function () {
      api.rerender('09957d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/61221000-4/internal/StepIdentification.vue"
export default component.exports